<template>
    <div class="ns-sf--view-section">
        <!-- Summary -->
        <el-row :gutter="20" style="max-width: 1400px; margin: 0 auto;">
            <el-col :sm="24" :md="6" :lg="6" class="ns-sf--summary-cell">
                <el-row class="ns-sf--summary-card text-center">
                    <p class="ns-sf--summary-title">Transactions</p>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Actual</p>
                        <p class="font-semibold">{{ summary_data.total_actual_transactions }}</p>
                    </el-col>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Forecast</p>
                        <p class="font-semibold">{{ summary_data.total_adjusted_transactions }}</p>
                    </el-col>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Accuracy</p>
                        <p class="font-semibold">{{ summary_data.transactions_accuracy }} %</p>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6" class="ns-sf--summary-cell">
                <el-row class="ns-sf--summary-card text-center">
                    <p class="ns-sf--summary-title">Sales</p>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Actual</p>
                        <p class="font-semibold">{{ summary_data.actual_sales ? currency + formatCurrency(summary_data.actual_sales) : '-' }}</p>
                    </el-col>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Forecast</p>
                        <p class="font-semibold">{{ summary_data.forecast_sales ? currency + formatCurrency(summary_data.forecast_sales) : '-' }}</p>
                    </el-col>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Accuracy</p>
                        <p class="font-semibold">{{ summary_data.sales_accuracy ? summary_data.sales_accuracy + ' %' : '-' }}</p>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :sm="24" :md="6" :lg="6" class="ns-sf--summary-cell">
                <el-row class="ns-sf--summary-card text-center">
                    <div class="flex items-center justify-center ns-sf--summary-title">
                        <p :class="!is_lc && 'text-amplitude'" class="ns-sf--head-sel cursor-pointer" @click="is_lc = false">Labour Hour</p>
                        <p class="ns-sf--head-sel mx-2">|</p>
                        <p :class="is_lc && 'text-amplitude'" class="ns-sf--head-sel cursor-pointer" @click="is_lc = true">Labour Cost</p>
                    </div>
                    <el-col :sm="24" :md="12" :lg="12" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Actual</p>
                        <p class="font-semibold">{{ is_lc ? currency + formatCurrency(summary_data.total_actual_labour_cost) : summary_data.total_actual_labour_hours + ' Hrs' }}</p>
                    </el-col>
                    <!-- <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Ideal</p>
                        <p class="font-semibold">{{ '-' }}</p>
                    </el-col> -->
                    <el-col :sm="24" :md="12" :lg="12" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Scheduled</p>
                        <p class="font-semibold">{{ is_lc ? currency + formatCurrency(summary_data.total_scheduled_labour_cost) : summary_data.total_scheduled_labour_hours + ' Hrs' }}</p>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :sm="24" :md="selected_forecast_view === 'sales' ? 4 : 6" :lg="selected_forecast_view === 'sales' ? 4 : 6" class="ns-sf--summary-cell">
                <el-row class="ns-sf--summary-card text-center">
                    <div class="flex items-center justify-center ns-sf--summary-title">
                        <p :class="is_tplh && 'text-amplitude'" class="ns-sf--head-sel cursor-pointer" @click="is_tplh = true">TPLH</p>
                        <p class="ns-sf--head-sel mx-2">|</p>
                        <p :class="!is_tplh && 'text-amplitude'" class="ns-sf--head-sel cursor-pointer" @click="is_tplh = false">IPLH</p>
                    </div>
                    <el-col :sm="24" :md="12" :lg="12" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Actual</p>
                        <p class="font-semibold">{{ is_tplh ? summary_data.actual_tplh : summary_data.actual_iplh }}</p>
                    </el-col>
                    <!-- <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Ideal</p>
                        <p class="font-semibold">{{ is_tplh ? summary_data.ideal_tplh : summary_data.ideal_iplh }}</p>
                    </el-col> -->
                    <el-col :sm="24" :md="12" :lg="12" class="flex items-center justify-center flex-col">
                        <p class="mb-1">Scheduled</p>
                        <p class="font-semibold">{{ is_tplh ? summary_data.scheduled_tplh : summary_data.scheduled_iplh }}</p>
                    </el-col>
                </el-row>
            </el-col>
            <el-col v-if="selected_forecast_view === 'sales'" :sm="24" :md="2" :lg="2" class="ns-sf--summary-cell">
                <el-row class="ns-sf--summary-card text-center">
                    <p class="ns-sf--summary-title">EFFICIENCY</p>
                    <el-col :sm="24" :md="8" :lg="8" class="flex items-center justify-center flex-col" style="width: 100%;">
                        <!-- <p class="mb-1">&nbsp;</p> -->
                        <p class="font-semibold">{{ efficiency_data.consolidated }} %</p>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>

        <!-- Chart -->
        <sales-forecast-chart class="mt-8" :graph-view="selected_view" :is-loading="table_loading" :graph-data="computedGraphData" />

        <!-- Table -->
        <div class="ns--sf-table-container ns--sf-day-hour-tbl">
            <!-- :span-method=" selected_forecast_view === 'sales' && selected_view === 'hour' ? handleSpanMethod : ''"  -->
            <el-table v-loading="table_loading" element-loading-text="Loading..." :data="computedTableData" style="width: 100%; max-width: 100%; overflow-x: auto;" height="650" class="ns-table" :header-cell-class-name="setCellClass">
                <el-table-column label="">
                    <el-table-column prop="forecast_week" :label="selected_view" :width="selected_view === 'day' ? 150 : 180">
                        <template slot-scope="scope">
                            <span v-if="selected_view === 'day' && !checkCompany.is_bt" class="text-amplitude font-semibold cursor-pointer" @click="handleDateClick('hour', scope.row.forecast_week)">{{ moment(scope.row.forecast_week, 'YYYY-MM-DD').format('DD MMM YY, ddd') }}</span>
                            <span v-else >{{ selected_view === 'day' ? moment(scope.row.forecast_week, 'YYYY-MM-DD').format('DD MMM YY, ddd') : scope.row.forecast_week }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="LAST YEAR - ACTUAL">
                    <el-table-column prop="prev_year_actual_sales" :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.prev_year_actual_sales !== '-' ? (currency + formatCurrency(scope.row.prev_year_actual_sales)) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.prev_year_actual_lab_hrs !== '-' ? scope.row.prev_year_actual_lab_hrs + ' Hrs' : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.prev_year_actual_transactions !== '-' ? (formatCurrency(scope.row.prev_year_actual_transactions)) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.prev_year_actual_lab_cost !== '-' ? ( currency + scope.row.prev_year_actual_lab_cost ) : '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="LAST WEEK - ACTUAL">
                    <el-table-column  :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.prev_week_actual_sales !== '-' ? (currency + formatCurrency(scope.row.prev_week_actual_sales)) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.prev_week_actual_lab_hrs !== '-' ? (scope.row.prev_week_actual_lab_hrs + ' Hrs') : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column   :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.prev_week_actual_transactions !== '-' ? (scope.row.prev_week_actual_transactions) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.prev_week_actual_lab_cost !== '-' ? (currency + formatCurrency(scope.row.prev_week_actual_lab_cost)) : '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="FORECAST"> 
                    <el-table-column :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.curr_forecast_sales !== '-' ?  (currency + formatCurrency(scope.row.curr_forecast_sales)) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.curr_forecast_lab_hrs !== '-' ?  (scope.row.curr_forecast_lab_hrs + ' Hrs') : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.curr_forecast_transactions !== '-' ?  (scope.row.curr_forecast_transactions) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.curr_forecast_lab_cost !== '-' ?  (currency + formatCurrency(scope.row.curr_forecast_lab_cost)) : '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="ACTUAL"> 
                    <el-table-column  :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.curr_actual_sales !== '-' ?  (currency + formatCurrency(scope.row.curr_actual_sales)) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.curr_actual_lab_hrs !== '-' ?  (scope.row.curr_actual_lab_hrs + ' Hrs') : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span v-if="selected_forecast_view === 'sales'" class="font-semibold">{{ scope.row.curr_actual_transactions !== '-' ?  (scope.row.curr_actual_transactions) : '-' }}</span>
                            <span v-else class="font-semibold">{{ scope.row.curr_actual_lab_cost !== '-' ?  (currency + formatCurrency(scope.row.curr_actual_lab_cost)) : '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-if="selected_forecast_view === 'sales'" label="ACCURACY %"> 
                    <el-table-column prop="sales_accuracy" :label="selected_forecast_view === 'sales' ? 'SALES' : 'LABOUR HRS'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span class="font-semibold">{{ scope.row.sales_accuracy !== '-' ? scope.row.sales_accuracy + ' %' : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="forecast_accuracy" :label="selected_forecast_view === 'sales' ? 'TRANSACTIONS' : 'LABOUR COST'" :width="selected_forecast_view === 'sales' && '150px'">
                        <template slot-scope="scope">
                            <span class="font-semibold">{{ scope.row.forecast_accuracy  !== '-' ? scope.row.forecast_accuracy + ' %' : '-'  }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <template v-if="selected_forecast_view === 'sales'" >
                    <el-table-column label="" width="150px">
                        <el-table-column :prop="efficiency_data.outlier" :label="selected_view === 'day' ? 'EFFICIENCY' : 'EFFICIENCY'" width="150px">
                            <template slot-scope="scope">
                                <span v-if="selected_view === 'day'" class="font-semibold">{{ scope.row.efficiency_data.efficiency }} %</span>
                                <span v-if="selected_view === 'hour'">
                                    <span v-if="scope.row.efficiency_data.outlier" class="font-semibold" style="color:#059669">YES</span>
                                    <span v-else class="font-semibold" style="color:#DC2626">NO</span>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </template>
                <!-- Add approve button column -->
                <template v-if="selected_view === 'day' && selected_forecast_view === 'sales' && selected_order_type === 'all'"  >
                    <el-table-column label="" fixed="right" width="150px">
                        <el-table-column label="APPROVE" fixed="right" width="150px">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.approved" type="success" plain round size="medium" @click="approveForecast(scope.row.forecast_week, scope.row.approved)">Approved</el-button>
                                <el-button v-else type="warning" plain round size="small" @click="approveForecast(scope.row.forecast_week, scope.row.approved)">Pending</el-button>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </template>
            </el-table>
        </div>

         <!-- Dialog -->
         <div v-if="approve_forecast_dialog">
            <el-dialog v-loading="forecast_popup_loading"
                :visible.sync="approve_forecast_dialog" fullscreen custom-class="ns-dialog" :show-close="false">
                <div class="font-semibold text-base cursor-pointer flex items-center mb-5 ml-4" style="font-size: 14px; width: fit-content;"
                    @click="approve_forecast_dialog = false"
                >
                <img src="../../../assets/icons/Back Arrow.png" alt="back" width="27px" class="mr-1">
                    Back
                </div>
                <div class="flex items-center justify-between mb-2 ml-5">
                    <p class="text-lg font-bold capitalize text-black"> {{ storeName }} -
                        <span class="capitalize">{{ set_selected_approve_date }}</span>
                        <span v-if="forecast_last_update_date && forecast_last_update_date.last_updated" class="text-base font-normal ml-8" style="font-size: 13px;">Last updated on {{ moment(forecast_last_update_date.last_updated, 'YYYY-MM-DD').format('Do MMM YY') }} </span>
                    </p>
                </div>
                 <!-- Graph -->
                <div class="flex items-center justify-end mt-8" style="margin-right: 9.5%">
                    <p :class="show_by === 'sales' && 'text-amplitude'" class="ns-sf--head-sel text-sm uppercase cursor-pointer font-semibold" @click="handleData('sales')">Sales</p>
                    <p class="ns-sf--head-sel mx-2">|</p>
                    <p :class="show_by === 'trx' && 'text-amplitude'" class="ns-sf--head-sel text-sm uppercase cursor-pointer font-semibold" @click="handleData('trx')">Transactions</p>
                </div>
                 <DayForecastGraph class="mb-8" :is-data-loaded="forecast_popup_loaded" :graph-label="graph_label" :graph-data="forecast_graph_data" />
                <ApproveForecast :store-name="storeName" :approve-dates-list="approve_dates_list" :selected-store="selected_store_id" :formatted-day="formattedDay"
                    :all-events="event_data" :event-categories="event_categories" :is-data-loaded="forecast_popup_loaded" :selected-date="set_selected_approve_date"
                    :forecast-data="forecast_approve_data" :forecast-data-clone="forecast_approve_data_clone" @updateAdjTrx="updateAdjTrx" @updateApproveDate="updateApproveDate" @closeAction="approve_forecast_dialog = false"/>
                <span slot="footer" class="dialog-footer">
                    <el-button class="ns-light-button" @click="approve_forecast_dialog = false">Cancel</el-button>
                    <el-button class="ns-button ns-sf--approve-btn cursor-pointer" :disabled="allow_approve || !isEditable"  @click="callApproveForecast()">{{ is_forecast_approved ? 'Approved' : 'Approve'}}</el-button>
                    <!-- <el-button class="ns-button ns-sf--approve-btn" :disabled="is_forecast_approved" :style="is_forecast_approved ? 'cursor: not-allowed;' : 'cursor:pointer;'" @click="is_forecast_approved ? '' : callApproveForecast()">{{ is_forecast_approved ? 'Approved' : 'Approve'}}</el-button> -->
                </span>
            </el-dialog>
        </div>
        <!-- Dialog -->

    </div>
</template>

<script>
import salesForecastMixin from '../../../../mixins/salesForecastMixin.js';
import salesForecastChart from '../graphs/SalesForecastChart.vue';
import ApproveForecast from '../dialogs/ApproveForecast.vue';
import DayForecastGraph from '../graphs/DayForecastGraph.vue';
    export default {
        name: "SalesForecastView",
        components: {
            salesForecastChart,
            ApproveForecast,
            DayForecastGraph
        },
        mixins: [salesForecastMixin],
        data() {
            return {
                is_tplh: true,
                is_lc: false
            }
        },
        computed: {

        },
        created() {

        },
        beforeDestroy() {

        },
        methods: {
            handleSpanMethod({ row, column, rowIndex, columnIndex }) {
                // console.log(row.forecast_week,rowIndex, ' AND ' ,  row.forecast_week.split('to')[0].split(':')[1].split(' ')[0], 'colspan');
                if(column.label === '+/- 5 VARIANCE'){
                    if(rowIndex === 0 && row.forecast_week.split('to')[0].split(':')[1].split(' ')[0] == 30) {
                        return {
                            rowspan: 1,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 2,
                            colspan: 1
                        };
                    }
                }
            },
            setCellClass({ row, column, rowIndex, columnIndex }) {
                console.log(row, column, rowIndex, columnIndex, 'row, column, rowIndex, columnIndex')
                if (column.label === 'FORECAST') {
                    return 'ns-forecast-forecast';
                }
            },
            formatCurrency(number){
                const result = new Intl.NumberFormat('en-IN').format(
                    number,
                );
                return result;
            }
        }
    }
</script>

<style lang="scss" scoped>
.ns-sf--summary-card{
    font-size: 14px;
    text-align: center;
}
.ns-sf--summary-title{
    font-size: 15px;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 13px;
}
.ns-sf--summary-cell:not(:last-child){
    border-right: 2px solid #D26300;
}


// not last child css

</style>

<style>
.ns--sf-table-container th .cell{
    font-size: 12px !important;
}
.ns--sf-table-container td .cell{
    font-size: 12px !important;
}
.ns-dialog .el-dialog__header {
    padding: 0px;
    /* background: #fdfdfd;
    color: #1c1b1b;
    border-radius: 8px; */
}

.ns-dialog.el-dialog {
    border-radius: 8px;
}

.ns-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #1c1b1b;
    font-weight: 700;
}

.ns-dialog .el-dialog__footer {
    /* position: fixed; */
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
    border-radius: 8px;
}
.ns-dialog .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-weight: 600;
    font-size: 25px;
}
.ns-sf--view-section .ns-dialog .el-dialog__footer {
    /* make fixed at bottom */
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
}
.ns-sf--view-section .ns-dialog .el-dialog__body{
    margin-bottom: 65px;
}
.ns-sf--action-header .el-input__inner{
    text-transform: capitalize;
}
.ns-sf--approve-btn{
    background: #D26300 !important
    ;
    color: #fff;
}
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr td:nth-child(6),
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr:not(:first-child) th:nth-child(6){
    border-left: 1px solid #fcc793 !important;
    border-right: 1px solid #fcc793 !important;
    border-bottom: 1px solid #fcc793 !important;
    background: #fcdcbd3f;
}

.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr td:nth-child(7),
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr:not(:first-child) th:nth-child(7){
    border-right: 1px solid #fcc793 !important;
    border-bottom: 1px solid #fcc793 !important;
    background: #fcdcbd3f;
}
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr th.ns-forecast-forecast{
    /* background: #f8ab6729 !important; */
    /* color: #fcc793 !important; */
    border-bottom: 1px solid #fcc793 !important;
    border-right: 1px solid #fcc793 !important;
    border-left: 1px solid #fcc793 !important;
    border-top: 1px solid #fcc793 !important;
    background: #fcdcbd3f;
}
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr:not(:first-child) th:nth-child(6),
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr:not(:first-child) th:nth-child(7),
.LabourPlaningDropdown .ns-sales-forecast .ns--sf-table-container.ns--sf-day-hour-tbl table tr th.ns-forecast-forecast{
    background: #fcdcbd7c !important;
}
</style>